import { defineStore } from 'pinia';
import { NotificationItem } from '@/models/notification';

export const useNotificationStore = defineStore('notification', () => {
    const items = ref<NotificationItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const notViewedNotifications = ref<any[]>([]);

    return {
        items,
        total,
        loading,
        notViewedNotifications,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot));
}
